import axios from 'axios'
import appTool from './appTool'

// 创建axios实例
const instance = axios.create({
    timeout: 60000,
    withCredentials: true // 允许携带cookie
})

// request拦截器
const setCookie = (name, value)=> {
    let days = 1;
    let expireDate = new Date();
    expireDate.setTime(expireDate.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + "=" + escape(value) + ";expires=" + expireDate.toGMTString();
}
instance.interceptors.request.use(
    config => {
        // 设置登录标记
        if (appTool.isLogin()) {
            let user = appTool.getLoginUserInfo()
            let url = config['url'];
            url += url.indexOf('?')>0 ? '&token=' : '?token=';
            url += user.data.token;
            config['url'] = url;
        }

        // 提交类型 form、json（默认）
        if (config.xPostType == 'form') {
            let str = ''
            for (let p in config.data) {
                str += encodeURIComponent(p) + '=' + encodeURIComponent(config.data[p]) + '&'
            }
            config.data = str;
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        }

        // ret
        return config
    }
)

// response拦截器
instance.interceptors.response.use(
    response => {
      // console.log(response)/
        if (response.data && response.data.code == '02') {
            // 登录凭据失效 需要重新登录
            appTool.store.clear();
            appTool.to({path: '/login'})
            return false;
        }
        return response
    },
    error => {
        // 返回状态码不为200
        appTool.eui.msg_error(error.toString());
        return Promise.reject(error)
    }
)

instance.install = (Vue) => {
    Vue.prototype.xFetch = instance
}

export default instance;



// WEBPACK FOOTER //
// ./src/common/fetch.js